import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { GenericForm } from "@/lib/Components/Form/Forms/GenericForm";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import {
  useGqlMutation,
  useSuspenseGqlQuery,
} from "@/lib/GraphQLCodegen/fetcher";
import { updateSupplierAdminContactMutation } from "@/app/Suppliers/GraphQL/supplierAdminContactMutations";
import { UpdateSupplierAdminContactInput } from "@/gql/graphql";
import { DialogSubmitButton } from "@/lib/Components/Dialog/Components/DialogSubmitButton";
import { supplierAdminContactRecord } from "@/app/Suppliers/GraphQL/supplierAdminContactList";
import { SupplierAdminContactForm } from "@/app/Suppliers/Forms/SupplierAdminContactForm";
import { toFormikValidationSchema } from "@/lib/Zod/zod-formik-adapter";
import { supplierAdminContactValidator } from "@/app/Suppliers/Validation/supplierAdminContactValidator";

export function SupplierAdminContactUpdateDialog({
  supplierAdminContactId,
}: {
  supplierAdminContactId: string;
}) {
  const { close } = useDialogState();
  const { mutateAsync } = useGqlMutation(updateSupplierAdminContactMutation);
  const { data } = useSuspenseGqlQuery(supplierAdminContactRecord, {
    id: supplierAdminContactId,
  });

  const contact = data.supplierAdminContact;

  return (
    <BaseDialog title="Update Contact">
      <GenericForm<UpdateSupplierAdminContactInput>
        initialValues={{
          name: contact.name,
          role: contact.role ?? "",
          email: contact.email ?? "",
          phone: contact.phone ?? "",
          description: contact.description ?? "",
        }}
        validationSchema={toFormikValidationSchema(
          supplierAdminContactValidator,
        )}
        onSubmit={async (values) => {
          await mutateAsync({ id: supplierAdminContactId, input: values });
          await close();
        }}
      >
        <SupplierAdminContactForm />
        <DialogSubmitButton text="Update Contact" />
      </GenericForm>
    </BaseDialog>
  );
}
